import React, { useCallback, useContext, useEffect, useState } from "react";
import './HistoricalData.css';
import { SurveyResultModel } from "../../models/SurveyResultModel";
import { AuthContext } from "../../core/context/authContext";
import { useLocation, useNavigate } from "react-router-dom";
import { getCollectionByProperties } from "../../core/firebase/firebaseFirestore";
import { QueryDocumentSnapshot } from "firebase/firestore";
import { useQuery } from "@tanstack/react-query";
import DatePicker from "../CustomDatePicker/CustomDatePicker";

const loginRoute = '/login';
const resultsCollectionName = 'results';

interface DatePickerRange {
    dateStart: number,
    dateEnd: number
}

const HistoricalData = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedDateRange, setSelectedDateRange] = useState<DatePickerRange>({ dateStart: 0, dateEnd: 0 });

    // const [resultsArray, setResultsArray] = useState<SurveyResultModel[]>([]);

    const noAuthenticatedStatus = 'no-authenticated';
    const { status } = useContext(AuthContext);

    const { data: resultsArray, refetch } = useQuery({
        queryKey: ['resultsData'],
        queryFn: () => getResults()
    });

    const getResults = useCallback(async () => {
        let dateRange = (selectedDateRange.dateEnd !== 0 ? selectedDateRange : null);
        let response = await getCollectionByProperties({ dateStart: dateRange?.dateStart, dateEnd: dateRange?.dateEnd, collectionName: resultsCollectionName });
        let results = mapResults(response?.docs);
        return results;
        // setResultsArray(results);
    }, [selectedDateRange]);

    const onDateChange = (dates: any) => {
        setSelectedDateRange(dates);
    }

    useEffect(() => {
        if (status === noAuthenticatedStatus) {
            navigate(loginRoute, { replace: true });
        }
    }, [status]);


    const mapResults = (firebaseSnapshots: QueryDocumentSnapshot[] | undefined) => {
        if (firebaseSnapshots) {
            return firebaseSnapshots.map((document) => document.data() as SurveyResultModel);
        }
        return [];
    }

    const showResults = (data: SurveyResultModel, type: string) => {
        navigate(
            '/resultado-diagnostico',
            {
                state: {
                    data,
                    type,
                    from: location.pathname
                }
            }
        );
    }

    const printData = () => {
        if (resultsArray) {
            if (resultsArray.length > 0) {
                return (resultsArray?.map((survey, index) => {
                    return (
                        <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{new Intl.DateTimeFormat('es-MX').format(survey.timestamp)}</td>
                            {(survey.hasContactData ?
                                <>
                                    <td>{survey.contactData?.fullName}</td>
                                    <td>{survey.contactData?.phone}</td>
                                    <td>{survey.contactData?.email}</td>
                                </>
                                : <td colSpan={3}>No hay datos</td>)}
                            <td>
                                <button className="btn btn-custom" onClick={() => showResults(survey, 'partial')}>Parciales</button>
                            </td>
                            <td>
                                <button className="btn btn-custom" onClick={() => showResults(survey, 'complete')}>Completos</button>
                            </td>
                        </tr>
                    )
                }));
            }

            return (
                <tr>
                    <td colSpan={7}>
                        <h5>No se encontraron resultados</h5>
                    </td>
                </tr>

            )
        }

    }

    return (
        <>
            <div className="title-container">
                <h1 className="text-center">Historial encuestas</h1>
            </div>
            <div className="table-wrapper">
                <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-12 col-12">
                        <DatePicker onDateChange={onDateChange} />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 col-12 text-center">
                        <button className="btn btn-custom" onClick={() => refetch()}>Buscar</button>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table text-center table-striped table-hover">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Fecha</th>
                                <th colSpan={3} scope="col">Datos de contacto</th>
                                <th colSpan={2} scope="col">Ver resultados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {printData()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default HistoricalData;